export default __webpack_public_path__ + "static/media/char_head_prem_001.8937f2d1.png";